import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  getContentEntityTypeNavigationsDataTable,
  getContentEntityTypeNavigationById,
  createContentEntityTypeNavigation,
  editContentEntityTypeNavigation,
} from './thunks';
import { ContentEntityTypeNavigationsState } from './types';

export const name = 'contentEntityTypeNavigations';

const initialState: ContentEntityTypeNavigationsState = {
  dataTable: {
    data: null,
    status: 'idle',
  },
  getById: { data: null, status: 'idle' },
  create: {
    data: null,
    status: 'idle',
  },
  edit: {
    data: null,
    status: 'idle',
  },
};

export const getContentEntityTypeNavigationsDataTableAsync = createAsyncThunk(
  name + '/getContentEntityTypeNavigationsDataTable',
  getContentEntityTypeNavigationsDataTable
);

export const getContentEntityTypeNavigationByIdAsync = createAsyncThunk(
  name + '/getContentEntityTypeNavigationById',
  getContentEntityTypeNavigationById
);

export const createContentEntityTypeNavigationAsync = createAsyncThunk(
  name + '/createContentEntityTypeNavigation',
  createContentEntityTypeNavigation
);

export const editContentEntityTypeNavigationAsync = createAsyncThunk(
  name + '/editContentEntityTypeNavigation',
  editContentEntityTypeNavigation
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
    clearContentEntityTypeNavigationById: (state) => {
      state.getById = {
        data: null,
        status: 'idle',
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        getContentEntityTypeNavigationsDataTableAsync.pending,
        (state) => {
          state.dataTable.status = 'loading';
        }
      )
      .addCase(
        getContentEntityTypeNavigationsDataTableAsync.fulfilled,
        (state, action) => {
          state.dataTable = {
            data: action.payload,
            status: 'idle',
          };
        }
      )
      .addCase(
        getContentEntityTypeNavigationsDataTableAsync.rejected,
        (state) => {
          state.dataTable.status = 'failed';
        }
      )
      .addCase(getContentEntityTypeNavigationByIdAsync.pending, (state) => {
        state.getById.status = 'loading';
      })
      .addCase(
        getContentEntityTypeNavigationByIdAsync.fulfilled,
        (state, action) => {
          state.getById = {
            data: action.payload,
            status: 'idle',
          };
        }
      )
      .addCase(getContentEntityTypeNavigationByIdAsync.rejected, (state) => {
        state.getById.status = 'failed';
      })
      .addCase(createContentEntityTypeNavigationAsync.pending, (state) => {
        state.create.status = 'loading';
      })
      .addCase(
        createContentEntityTypeNavigationAsync.fulfilled,
        (state, action) => {
          state.create = {
            data: action.payload,
            status: 'idle',
          };
        }
      )
      .addCase(createContentEntityTypeNavigationAsync.rejected, (state) => {
        state.create.status = 'failed';
      })

      .addCase(editContentEntityTypeNavigationAsync.pending, (state) => {
        state.edit.status = 'loading';
      })
      .addCase(
        editContentEntityTypeNavigationAsync.fulfilled,
        (state, action) => {
          state.edit = {
            data: action.payload,
            status: 'idle',
          };
        }
      )
      .addCase(editContentEntityTypeNavigationAsync.rejected, (state) => {
        state.edit.status = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
